// Classic script. Extends <modal-dialog> via the custom-elements registry
// because `ModalDialog` is module-scoped in secondary.js (post-Tier-4) and
// no longer on globalThis. Defer ordering guarantees secondary.js has
// already registered modal-dialog by the time this script executes.
if (!customElements.get('product-modal')) {
  const ModalDialogClass = customElements.get('modal-dialog');
  if (ModalDialogClass) {
    customElements.define('product-modal', class ProductModal extends ModalDialogClass {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        // Guard against show() being called without an opener — `this.openedBy`
        // is undefined in that case and would throw on .getAttribute().
        if (!this.openedBy) return;
        const mediaId = this.openedBy.getAttribute("data-media-id");
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${mediaId}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) return;
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        if (container) {
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        }

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }
}
